<template>
    <a-row>
        <a-row type="flex" justify="start" class="routesTitle" align="middle">
            <a-col class="ml4">Waypoints</a-col>
        </a-row>
        <a-row style="border: 1px solid gray;padding:4px">
            <a-row type="flex" justify="space-between">
                <a-col>
                    <a-row type="flex" justify="start" align="middle">
                       <!-- <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>{{ $t('roleGe.Add') }}</span>
                            </template>
                            <img class="sbxs mllr4" src="../../../assets/img/ss-add.png"  width="22" height="22" @click="add">
                        </a-tooltip>-->
                        <a-popconfirm
                                :title="$t('pubGicSet.AreyoudeleTask')"
                                :okText="$t('pubGicSet.Yes')"
                                :cancelText="$t('pubGicSet.No')"
                                @confirm="delWay"
                        >
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>{{ $t('roleGe.Delete') }}</span>
                                </template>
                                <img class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
                            </a-tooltip>
                        </a-popconfirm>
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>Refresh</span>
                            </template>
                            <img class="sbxs mllr4" style='margin-top: 2px' src="../../../assets/img/ss-refresh.png" width="22" height="20" @click="init">
                        </a-tooltip>
                        <a-button type="primary" size="small" class="ml4" @click="splitRouteBtn">Split Route Button</a-button>
                    </a-row>
                </a-col>
                <a-col>
                    <a-pagination
                            :pageSizeOptions="wapPoints.pageSizeOptions"
                            :showTotal="total => `${$t('generic.totalOf')} ${wapPoints.pagingTotal} ${$t('generic.Records')}`"
                            size="small"
                            :total="wapPoints.pagingTotal"
                            v-model="wapPoints.currentVal"
                            :pageSize.sync="wapPoints.pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            showSizeChanger
                    />
                </a-col>
            </a-row>
            <a-row class="mt4">
                <a-row id="waypointDrop">
                    <vxe-table
                        stripe
                        resizable
                        border
                        show-header-overflow
                        show-overflow
                        highlight-hover-row
                        size="mini"
                        @cell-dblclick="dbClickEdit"
                        @cell-click="clickRow"
                        :cell-class-name="cellClassName"
                        ref="wayPointsTableRef"
                        class="mytable-style"
                        :height="wapPointsHeight"
                        :data="tableData">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;"></span>
                        </template>
                        <vxe-table-column width="50">
                            <template v-slot>
                              <span class="drag-btn">
                                <i class="vxe-icon--menu"></i>
                              </span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                        <vxe-table-column field="lineNo" title="Line" width="70" sortable></vxe-table-column>
                        <vxe-table-column field="wayNo" title="Way No." width="130" sortable></vxe-table-column>
                        <vxe-table-column field="status" title="Status" width="70">
                            <template v-slot="{ row }">
                                {{ row.status | filterSatus}}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="address" title="Address"></vxe-table-column>

                        <vxe-table-column field="mapWayLongitude" title="Map Way Longitude" :visible="false"></vxe-table-column>
                        <vxe-table-column field="mapWayLatitude" title="Map Way Latitude" :visible="false"></vxe-table-column>

                    </vxe-table>
                </a-row>
            </a-row>
        </a-row>
        <a-modal v-model="visible" title="Waypoints" width="50%" :maskClosable="false">
            <template slot="footer">
                <a-button type="primary" size="small"  @click="saveWay">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="form" >
                <a-row :gutter="24">
                    <a-col :span="12">
                        <a-form-item label="Map Way Address 1" class="genericFrom">
                            <a-input
                                size="small"
                                v-decorator="['mapWayAddress1',
                                     {
                                          initialValue: wayPointsFromVal.mapWayAddress1,
                                     }
                                 ]"
                               />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="Map Way Address 2" class="genericFrom">
                            <a-input
                                size="small"
                                v-decorator="['mapWayAddress2',
                                     {
                                          initialValue: wayPointsFromVal.mapWayAddress2,
                                     }
                                 ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="Map Way Address 3" class="genericFrom">
                            <a-input
                                    size="small"
                                    v-decorator="['mapWayAddress3',
                                     {
                                          initialValue: wayPointsFromVal.mapWayAddress3,
                                     }
                                 ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="Map Way City" class="genericFrom">
                            <a-input
                                    size="small"
                                    v-decorator="['mapWayCity',
                                     {
                                          initialValue: wayPointsFromVal.mapWayCity,
                                     }
                                 ]"

                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="Map Way Suburb" class="genericFrom">
                            <a-input
                                    size="small"
                                    v-decorator="['mapWaySuburb',
                                     {
                                          initialValue: wayPointsFromVal.mapWaySuburb,
                                     }
                                 ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="Map Way Province" class="genericFrom">
                            <a-input
                                    size="small"
                                    v-decorator="['mapWayProvince',
                                     {
                                          initialValue: wayPointsFromVal.mapWayProvince,
                                     }
                                 ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="Map Way Country" class="genericFrom">
                            <a-input
                                    size="small"
                                    v-decorator="['mapWayCountry',
                                     {
                                          initialValue: wayPointsFromVal.mapWayCountry,
                                     }
                                 ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="Map Way Postal Code" class="genericFrom">
                            <a-input
                                    size="small"
                                    v-decorator="['mapWayPostalCode',
                                     {
                                          initialValue: wayPointsFromVal.mapWayPostalCode,
                                     }
                                 ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="Map Way Postal Longitude" class="genericFrom">
                            <a-input
                                    size="small"
                                    v-decorator="['mapWayLongitude',
                                     {
                                          initialValue: wayPointsFromVal.mapWayLongitude,
                                     }
                                 ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="Map Way Postal Latitude" class="genericFrom">
                            <a-input
                                    size="small"
                                    v-decorator="['mapWayLatitude',
                                     {
                                          initialValue: wayPointsFromVal.mapWayLatitude,
                                     }
                                 ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>
    </a-row>

</template>
<script>
    import Sortable from "sortablejs";
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        props:{
            wapPointsHeight: {
                type: Number,
                default: ()=>{
                    return 100
                }
            },
            routesHeaderUId: {
                type: String,
                default: ()=>{
                    return null
                }
            },
        },
        data(){
            return{
                tableData: [],
                oldTable: [],
                wapPoints: {
                    pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                    pagingTotal:0,
                    currentVal: 1,
                    pagingSize: 10
                },
                visible: false,
                form: this.$form.createForm(this),
                selectRow:{},
                wayPointsFromVal: {}
            }
        },
        created () {
            this.rowDrop()
        },
        beforeDestroy () {
            if (this.sortable) {
                this.sortable.destroy()
            }
        },
        filters: {
            filterSatus(val) {
                let data = JSON.parse(sessionStorage.getItem('localData'))
                data = data.TMS_ROUTE_WAY_STATUS
                for(let i in data){
                    if(val == data[i].CODE){
                        return data[i].CODE_DESC
                    }
                }
            }
        },
        watch:{
            routesHeaderUId(v){
                this.init()
            }
        },
        methods: {
//            Split Route Button
            splitRouteBtn(){
                let len = this.$refs.wayPointsTableRef.getCheckboxRecords()
                if(len.length > 0){
                    let arr = []
                    for(let i in len){

                        let waypointStatus = len[i].status
                        let waypoint = len[i].wayNo;
                        if(waypointStatus=='99'){
                            this.$customMessage.warning(waypoint+" has already completed, don't allowed to be split.");
                            return;
                        }else{
                            arr.push(len[i].uid)
                        }
                    }
                    let params = {
                        routeHeaderUid: this.routesHeaderUId,
                        routeWayUids:arr.toString()
                    }
                    ajax.post(api.TMSSPLITROUTE,params).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            //this.init()
                            this.$emit('emitDeliveriesUid','Orderinit')
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                }
            },
//            删除way
            delWay(){
                let len = this.$refs.wayPointsTableRef.getCheckboxRecords()
                if(len.length > 0){
                    let arr = []
                    for(let i in len){arr.push(len[i].uid)}
                    let params = {
                        routeHeaderUid: this.routesHeaderUId,
                        routeWayIds:arr.toString()
                    }
                    ajax.post(api.TMSDELETEROUTEWAY,params).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.init()
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                }
            },
            //      分页
            onShowSizeChange(current, pageSize) {
                this.wapPoints.currentVal = current;
                this.wapPoints.pagingSize = pageSize;
                this.init()
            },
            //      分页
            tableChangePage(current) {
                this.wapPoints.currentVal = current;
                this.init()
            },
//            初始化数据
            init(type){
                if(type == 'sort' || type == 'routes'){
                    this.tableData = []
                }
                if(this.routesHeaderUId===null){
                    this.tableData = null;
                    this.$emit('emitWayUid',null)
                    this.$emit('waypointNo',null)
                }else {
                    let params = {
                        headerId:this.routesHeaderUId,
                        pageNumber:this.wapPoints.currentVal,
                        pageSize: this.wapPoints.pagingSize
                    }
                    ajax.get(api.TMSGETROUTEWAYS,params).then(res=>{
                        this.tableData = res.data
                        this.oldTable = res.data
                        this.wapPoints.pagingTotal = res.total
                        if(this.tableData.length > 0){
                            this.selectRow = this.tableData[0]
                            this.$refs.wayPointsTableRef.setCheckboxRow([this.selectRow], true)
                            this.$emit('emitWayUid',this.selectRow.uid)
                            this.$emit('waypointNo',this.selectRow.wayNo)


                            let gmapPolylineList = [];
                            let gmapColorLineList = [];
                            for(let index in this.tableData){
                                if(null!=this.tableData[index].mapWayLongitude && null!=this.tableData[index].mapWayLatitude){
                                    let mapWayLongitude = Number.parseFloat(this.tableData[index].mapWayLongitude);
                                    let mapWayLatitude = Number.parseFloat(this.tableData[index].mapWayLatitude);
                                    console.log("mapWayLongitude:"+mapWayLongitude+",mapWayLatitude:"+mapWayLatitude)
                                    gmapPolylineList.push({ lat: mapWayLatitude, lng: mapWayLongitude });
                                    gmapColorLineList.push({strokeColor:'#'+index+'08000'});
                                }
                            }
                            var googleMapLineList = {
                                gmapPolylineList:gmapPolylineList,
                                gmapColorLineList:gmapColorLineList
                            }
                            this.$emit('googleMapLineList',googleMapLineList)

                        }else{
                            this.$emit('emitWayUid',null)
                            this.$emit('waypointNo',null)
                            this.$emit('emitDeliveriesUid','Orderinit')

                        }
                    })
                }

            },
            saveWay(){
                this.form.validateFields((err, values) => {
                    if (!err) {
                        let params = values
                        if(this.wayPointsFromVal.uid){
                            params.uid = this.wayPointsFromVal.uid
                        }
                        params.routeHearderUid = this.routesHeaderUId
                        ajax.post(api.TMSSAVEROUTEWAY,params).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.visible = false
                                this.init()
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                });
            },
            //            单击当前行变色
            cellClassName({ row }) {
                if (row === this.selectRow) {
                    return "rorClass";
                }
            },
//            点击当前
            clickRow({row,column}){
                if(column.title != undefined){
                    this.$refs.wayPointsTableRef.setCheckboxRow([this.selectRow], false)
                    this.$emit('emitWayUid',row.uid)
                    this.$emit('waypointNo',row.wayNo)
                    this.selectRow = row
                    this.$refs.wayPointsTableRef.setCheckboxRow([this.selectRow], true)
                }
            },
//            添加 编辑
            add(){
                this.visible = true
                this.wayPointsFromVal = {}
                this.form.resetFields();
            },
            dbClickEdit({row}){
                this.visible = true
                this.form.resetFields();
                ajax.get(api.TMSGETROUTEWAY,{id: row.uid}).then(res=>{
                    this.wayPointsFromVal = res.data
                })
            },
//            拖拽
            rowDrop () {
                let that = this
                this.$nextTick(() => {
                    let wayPointsTableRef = this.$refs.wayPointsTableRef
                    this.sortable = Sortable.create(wayPointsTableRef.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                        handle: '.drag-btn',
                        group: {
                            name:'rw',
                            put: false
                        },
//                        table 排序
                        onEnd: ({ newIndex, oldIndex }) => {
                            if(newIndex == oldIndex){
                                return
                            }else{
                                let table = JSON.parse(JSON.stringify(that.tableData))
                                let params = {
                                    dragRowUid: that.tableData[oldIndex].uid,
                                    hoverRowUid: table[newIndex].uid
                                }
                                ajax.post(api.TMSSORTWAY,params).then(res=>{
                                    if(res.code == 200){
                                        that.init('sort')
                                    }
                                })
                            }
                        },
                        onRemove: function (/**Event*/evt) {
                            let len = that.$refs.wayPointsTableRef.getCheckboxRecords()
                            let arr = []
//                                多条沟中一起托
                            if(len.length == 0){
                                arr.push(that.oldTable[evt.oldIndex].uid)
                            }else{
                                for(let i in len){
                                    arr.push(len[i].uid);
                                }
//                                    拖拽当前 但没有勾选
                                if (arr.indexOf(that.oldTable[evt.oldIndex].uid)  == -1) {
                                    arr.push(that.oldTable[evt.oldIndex].uid)
                                }
                            }
                            if(that.$parent.getrRourtesRef().length == 2){
                                let touid = null
                                let ids = that.$parent.getrRourtesRef()
                                for(let i in ids){
                                    if(ids[i].uid != that.routesHeaderUId){
                                        touid =  ids[i].uid
                                    }
                                }
                                let params = {
                                    fromUid: that.routesHeaderUId,
                                    toUid: touid,
                                    wayUids: arr.toString(),
                                    flag:'waypoint'
                                }
                                that.$store.commit("updatatmsDrag", { tmsDrag: params });
                            }else{
                                that.$customMessage.warning('Routes -- Please select one record only');
                                that.init('routes')
                            }
                        },
                    })

                   let waypointDrop = document.getElementById('waypointDrop')
                    //拖拽orders
                    this.sortable = Sortable.create(waypointDrop, {
                        handle: '.drag-btn',
                        group: {name:'od'},
                        sort: false,
                    })
                })
            },
        }
    }
</script>
<style>
    #waypointDrop>tr{
        display: none;
    }
    .mytable-style .vxe-body--column.rorClass {
        background-color: #73459d;
        color: #fff;
    }
</style>